module.exports = __webpack_public_path__ + "archivist_frustrazione.gif?85428b86abf89d74b9519360b659afae";


//////////////////
// WEBPACK FOOTER
// ./src/img/animazioni/archivist_frustrazione.gif
// module id = 368
// module chunks = 0